const SET_BRANCHES = 'SET_BRANCHES';
const SET_DS_BRANCHES = 'SET_DS_BRANCHES';
const SET_DS_PUBLISHED_BRANCH_ID = 'SET_DS_PUBLISHED_BRANCH_ID';

export { SET_BRANCHES, SET_DS_BRANCHES, SET_DS_PUBLISHED_BRANCH_ID };
